import { ArrowRight, HardHat } from "lucide-react";
import { IMAGES } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { useSectionNav } from "@/hooks/useSectionNav";

const Fleet = () => {
  const go = useSectionNav();
  const requestFleet = () => {
    window.dispatchEvent(new CustomEvent("prefill-vehicle", { detail: "Work Vehicle" }));
    go("quote");
  };
  return (
    <section className="border-y border-white/10 bg-surface" data-testid="fleet-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-5 py-20 sm:px-8 sm:py-24 lg:grid-cols-2">
        <Reveal y={36}>
          <div className="relative h-64 overflow-hidden border border-white/10 sm:h-80">
            <img src={IMAGES.truck} alt="Work truck being pressure washed" loading="lazy" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 to-transparent" aria-hidden="true" />
          </div>
        </Reveal>
        <div>
          <Reveal>
            <p className="eyebrow flex items-center gap-3">
              <HardHat size={15} strokeWidth={2} aria-hidden="true" />
              For Local Businesses
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
              Work Trucks &amp; Small Fleets
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="mt-6 max-w-lg space-y-4 text-base leading-relaxed text-slate-300">
              <p>
                Own a local business or manage multiple vehicles? Freedom Mobile Auto Detailing can also provide
                recurring cleaning for work trucks and small fleets.
              </p>
              <p className="text-slate-400">
                Pricing for commercial or recurring fleet service is quoted individually depending on vehicle count,
                size, condition, and cleaning frequency.
              </p>
            </div>
            <button onClick={requestFleet} className="btn-primary mt-8" data-testid="fleet-pricing-button">
              Request Fleet Pricing
              <ArrowRight size={17} strokeWidth={2.4} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Fleet;
